var map = {
	"./resultLogo1.png": 2008,
	"./resultLogo10.png": 7630,
	"./resultLogo11.png": 887,
	"./resultLogo12.png": 2294,
	"./resultLogo2.png": 2659,
	"./resultLogo3.png": 147,
	"./resultLogo4.png": 7272,
	"./resultLogo5.png": 8630,
	"./resultLogo6.png": 5129,
	"./resultLogo7.png": 665,
	"./resultLogo8.png": 5398,
	"./resultLogo9.png": 8598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2000;